import React, { type FC } from 'react'
import type { SxProps, Theme } from '@mui/material'

import { ConnectwareError, ConnectwareErrorType, selectAuthenticatedCapabilities, selectAuthenticatedUsername, Translation } from '../../../../domain'
import { DocumentationType } from '../../../../application'

import { ErrorMessage } from '../../ErrorMessage'
import { useAppState } from '../../State'
import { FormattedTranslation, useTranslator } from '../../Internationalization'
import { DocumentationLink } from '../../Documentation'
import type { AbsoluteRoutePath } from '..'
import { getRouteCapabilities, getRouteInternalPath } from '../Config'

const linkStyle: SxProps<Theme> = { ml: 1 }

export const DeniedAccess: FC<{ path: AbsoluteRoutePath }> = ({ path }) => {
    const translator = useTranslator()

    const route = getRouteInternalPath(path)
    const capabilitiesAlternatives = getRouteCapabilities(path)
    const username = useAppState(selectAuthenticatedUsername)
    const userCapabilities = useAppState(selectAuthenticatedCapabilities)

    return (
        <ErrorMessage
            error={
                new ConnectwareError(ConnectwareErrorType.AUTHENTICATION, translator.formatTranslation(Translation.AUTHENTICATION_ERROR_TITLE), {
                    routeId: path,
                    route,
                    capabilitiesAlternatives,
                    username,
                    userCapabilities,
                })
            }
            customTitle={(e) => e.message}
            extrasTitleSuffix={
                <DocumentationLink type={DocumentationType.UI_ACCESS_PERMISSIONS} sx={linkStyle} data-testid="ui-access-documentation" variant="body2">
                    <FormattedTranslation id={Translation.ABOUT_UI_ACCESS_PERMISSIONS} />
                </DocumentationLink>
            }
            extras="section"
        />
    )
}
